import React, { useState, useEffect, useContext, useRef } from "react";
import { BACKEND_URL } from "../../global";
import { Button } from "../../shadcnComponents/ui";
import { Card, CardHeader, CardTitle, CardContent, CardDescription, CardAction } from '../../shadcnComponents/ui/card';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { Dashboard } from "@uppy/react";
import { pathFromFolderchain } from "../functions";
import { LocationContext } from '../../contextProvider';
import Uppy from "@uppy/core";
import './uppy.css';
import GoogleDrive from "@uppy/google-drive";
import OneDrive from "@uppy/onedrive";
import GoogleDrivePicker from '@uppy/google-drive-picker';
import XHR from "@uppy/xhr-upload";
import "@uppy/core/css/style.css";
import "@uppy/dashboard/css/style.css";
import keycloak from '../../keycloak';
import Greek from '@uppy/locales/lib/el_GR';


export const UppyModal = (props) => {
    const [uppyInstance, setUppyInstance] = useState(null);
    const locationContext = useContext(LocationContext)
    const folderChain = useRef(null)
    const fileMap = useRef(null)
    const config = {
        Authorization: `Bearer ${keycloak.token}`
    }
    const translation = Greek

    useEffect(() => {
        // Initialize Uppy instance
        console.log(translation)
        translation.strings.pickFiles = "Επέλεξε αρχεία";
        translation.strings.selectX = "Επέλεξε";
        translation.strings.cancel = "Άκυρο";
        translation.strings.unnamed = "Χωρίς όνομα";
        const uppy = new Uppy({
            autoProceed: false,
            allowMultipleUploadBatches: false,
            restrictions: {
                maxNumberOfFiles: 5,
                allowedFileTypes: ["audio/*", "video/*"],
            },
            locale: Greek
        })
            // .use(GoogleDrive, {
            //     companionUrl: "https://apps.ilsp.gr:3021", // Replace with your own Companion server in production
            // })
            .use(GoogleDrivePicker, {
                companionUrl: "https://apps.ilsp.gr:3021",
                clientId: "773927495811-3t111bj7pdb3cemj6r1o1htcgbpegt93.apps.googleusercontent.com",
                apiKey: "AIzaSyCk3RMEkdufs3RBswQqZLXv0UYhUKFXB_U",
                appId: '773927495811',
                locale: Greek
            })
            .use(OneDrive, {
                companionUrl: "https://apps.ilsp.gr:3021", // Same as above
            })
            .use(XHR, {
                endpoint: `${BACKEND_URL}/upload_audio`, // Replace with your backend endpoint
                formData: true,
                fieldName: 'file',
                bundle: false,
                allowedMetaFields: ['path', 'filename', 'fieldName', 'interview_id'],
                headers: config
            });
        uppy.on('file-added', (file) => {
            if (file) {
                let path = pathFromFolderchain(folderChain.current)
                uppy.setFileMeta(file.id, {
                    ...file.meta,
                    path: path,
                    filename: file.name,
                    interview_id: file.name,
                    fieldName: 'file'
                });
            }
        });
        uppy.on('complete', data => {
            let completeUploads = []
            data.successful.map(each => {
                completeUploads.push(each.response.body)
            })
            updateState(completeUploads)
        })
        setUppyInstance(uppy);
    }, []);

    useEffect(() => {
        folderChain.current = props.folderChain
        fileMap.current = props.fileMap
    }, [props])


    function updateState(data) {
        // Takes an array of files as input, where file is the response object from the backend
        let newFiles = data
        const currentFolderId = folderChain.current[folderChain.current.length - 1].id
        const newFileMap = { ...fileMap.current };
        const parent = newFileMap[currentFolderId];
        let newFolderChain = [...folderChain.current]
        newFiles.map(newFile => {
            newFileMap[newFile.created_at] = {
                color: "rgb(195, 186, 240)",
                id: newFile.created_at,
                interview_id: newFile.id,
                isDir: false,
                modDate: newFile.created_at,
                name: newFile.interview_id,
                parentId: currentFolderId,
                path: newFile.path,
                size: true,
                transcribed: false,
                transcriptionStatus: "NOT_TRANSCRIBED",
                groups: newFile.groups
            }
        })
        let newFileIdsArray = []
        newFiles.map(newFile => {
            newFileIdsArray.push(newFile.created_at)
        })
        // Update parent folder to reference the new folder.
        newFileMap[currentFolderId] = {
            ...parent,
            childrenIds: [...parent.childrenIds, ...newFileIdsArray],
            childrenCount: parent.childrenCount + 1
        };
        newFolderChain[newFolderChain.length - 1] = newFileMap[currentFolderId]
        props.updateFileMap(newFileMap)
        props.updateFolderChain(newFolderChain)
        locationContext.setFolderChain(newFolderChain)
        // Close uppy dialogue 
        // hideUppyDialogue()
    }

    function hideUppyDialogue() {
        let backButton = document.getElementsByClassName('uppy-DashboardContent-back')[0] || document.getElementsByClassName('uppy-StatusBar-actionBtn--done')[0]
        if (backButton) {
            backButton.click()
        }
        document.getElementById('modal-upload').classList.add('hidden')
    }

    return (
        <div id='modal-upload' className="hidden fixed z-10 w-screen h-screen top-0 left-0 bg-secondary-background flex items-center justify-center overflow-y-auto">
            <Card className='w-[40rem] min-h-fit'>
                <CardHeader>
                    <CardTitle>Προσθήκη αρχείου</CardTitle>
                    <CardDescription>
                        Επιλέξτε από πού θέλετε να μεταφορτώσετε το αρχείο
                    </CardDescription>
                    <CardAction>
                        <Button onClick={() => { hideUppyDialogue() }} variant="link">
                            <XMarkIcon className='size-6' />
                        </Button>
                    </CardAction>
                </CardHeader>
                <CardContent className="h-fit">
                    {uppyInstance && (
                        <Dashboard
                            height={'400px'}
                            uppy={uppyInstance}
                            proudlyDisplayPoweredByUppy={false}
                            plugins={["GoogleDrive", "OneDrive"]}
                            note="Για τη χρήση Google Drive και OneDrive απαιτείται σύνδεση"
                        />
                    )}
                </CardContent>
            </Card>
        </div>
    );
};

export default UppyModal;
